import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import RecoveryPage from "../pages/Authentications/Recovery";
import ThankYouView from "../pages/Authentications/ThankYouView";
import { ProtectedRoute, AdminRoute, CustomerRoute } from "../components/ProtectedRoute";
import AccountAppLayout from "./AccountAppLayout";

const SingUpPage = lazy(() => import("../pages/Authentications/SignUp"));
const SingInPage = lazy(() => import("../pages/Authentications/SignIn"));
const VerifyEmailPage = lazy(() => import("../pages/Authentications/VerifyEmail"));

const Dashboard = lazy(() => import("../pages/Account/Dashboard"));
const MyQuotes = lazy(() => import("../pages/Account/Quotes"));
const QuoteDetail = lazy(() => import("../pages/Account/Quotes/QuoteDetail"));
const SavedCars = lazy(() => import("../pages/Account/Saved"));
const ProfileSettings = lazy(() => import("../pages/Account/Profile"));
const ActivatePage = lazy(() => import("../pages/Account/Activate"));
const RequestQuote = lazy(() => import("../pages/Account/RequestQuote"));
const AdminQuotes = lazy(() => import("../pages/Account/Admin"));

const AccountLayout: React.FC = (): React.ReactElement => {
    return (
        <Routes>
            {/* Public auth screens */}
            <Route path='/sign-up' element={<SingUpPage />} />
            <Route path='/sign-up/success' element={<ThankYouView type='VERIFY' />} />
            <Route path='/sign-in' element={<SingInPage />} />
            <Route path='/verify-email' element={<VerifyEmailPage />} />
            <Route path='/recovery' element={<RecoveryPage />} />
            <Route path='/recovery/success' element={<ThankYouView type='RESET' />} />

            {/* Authenticated account area (header + sidebar). Customer pages are
                wrapped in CustomerRoute so admins (who don't trade) are bounced
                to the admin panel; Profile is shared by both. */}
            <Route
                element={
                    <ProtectedRoute>
                        <AccountAppLayout />
                    </ProtectedRoute>
                }>
                <Route path='/dashboard' element={<CustomerRoute><Dashboard /></CustomerRoute>} />
                <Route path='/activate' element={<CustomerRoute><ActivatePage /></CustomerRoute>} />
                <Route path='/quotes' element={<CustomerRoute><MyQuotes /></CustomerRoute>} />
                <Route path='/quotes/:id' element={<CustomerRoute><QuoteDetail /></CustomerRoute>} />
                <Route path='/saved' element={<CustomerRoute><SavedCars /></CustomerRoute>} />
                <Route path='/profile' element={<ProfileSettings />} />
            </Route>

            {/* Full-page request form (customer-only, own layout).
                With :vehicleId it pre-fills from a listing; without it, it's a
                blank "request any car" form. */}
            <Route
                path='/request-quote'
                element={
                    <CustomerRoute>
                        <RequestQuote />
                    </CustomerRoute>
                }
            />
            <Route
                path='/request-quote/:vehicleId'
                element={
                    <CustomerRoute>
                        <RequestQuote />
                    </CustomerRoute>
                }
            />

            {/* Admin */}
            <Route
                element={
                    <AdminRoute>
                        <AccountAppLayout />
                    </AdminRoute>
                }>
                <Route path='/admin' element={<AdminQuotes />} />
            </Route>
        </Routes>
    );
};

export default AccountLayout;
